var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form popup-application-help"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('button', {
    staticClass: "back-button-wrapper pointer",
    attrs: {
      "type": "button",
      "aria-label": "Zavrieť metodiku"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "close",
      "size": 23
    }
  })], 1)]), _c('knowledge-base-panel', {
    attrs: {
      "initial-bank": _vm.initialBank
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }